/**
 * Central section registry. Keeps the IA order in one place.
 * Sections are filed numerically so the directory sorts by IA order too.
 */
import { GuideSection } from './types';

import quickStart       from './01-quick-start';
import concepts         from './02-concepts';
import dashboard        from './03-dashboard';
import analytics        from './03a-analytics';
import trades           from './04-trades';
import autotrade        from './04a-autotrade';
import alerts           from './05-alerts';
import charts           from './06-charts';
import watchlist        from './06a-watchlist';
import optionsWorkspace from './06b-options-workspace';
import sniper           from './07-strategy-sniper';
import rockband         from './08-strategy-rockband';
import dailyblast       from './09-strategy-dailyblast';
import shavedDoji       from './09a-strategy-shaveddoji';
import omSimple         from './09b-strategy-omsimple';
import vajra            from './09c-strategy-vajra';
import clnBreak         from './09d-strategy-clnbreak';
import gandiv           from './09e-strategy-gandiv';
import lrCross          from './09f-strategy-lrcross';
import indicators       from './10-indicators';
import clhBandGuide     from './10a-indicator-clhband';
import orderFlow        from './11-order-flow';
import fnoOptions       from './12-fno-options';
import optionsAt        from './12a-options-at';
import edgeAi           from './12b-edge-ai';
import aiDesk           from './12f-ai-desk';
import backtest         from './12c-backtest';
import smartMoney       from './12d-smart-money';
import syntheticSymbols from './12e-synthetic-symbols';
import goldenSignals    from './12g-golden-signals';
import tvSetup          from './13-tradingview-setup';
import brokerSetup      from './14-broker-setup';
import settings         from './15-settings';
import riskManagement   from './16-risk-management';
import hotkeys          from './17-hotkeys';
import glossary         from './18-glossary';
import troubleshooting  from './19-troubleshooting';
import legal            from './20-legal';
import terms            from './20a-terms';
import privacy          from './20b-privacy';
import riskDisclaimer   from './20c-risk';
import whatsNew         from './21-whats-new';
import e2eTests         from './22-e2e-tests';

export const SECTIONS: GuideSection[] = [
  quickStart, concepts,
  dashboard, analytics, trades, autotrade, alerts, charts, optionsWorkspace, watchlist,
  sniper, rockband, dailyblast, shavedDoji, omSimple, vajra, clnBreak, gandiv, lrCross,
  clhBandGuide,
  indicators, orderFlow, fnoOptions, optionsAt, syntheticSymbols, goldenSignals, aiDesk, edgeAi, smartMoney, backtest,
  tvSetup, brokerSetup, settings, riskManagement,
  hotkeys, glossary, troubleshooting,
  e2eTests,
  legal, terms, privacy, riskDisclaimer,
  whatsNew,
];

export const SECTION_BY_ID: Record<string, GuideSection> = SECTIONS.reduce((acc, s) => {
  acc[s.id] = s;
  return acc;
}, {} as Record<string, GuideSection>);

export const GROUPS: Array<{ id: GuideSection['group']; label: string }> = [
  { id: 'getting-started', label: 'Getting Started' },
  { id: 'pages',           label: 'Pages' },
  { id: 'strategies',      label: 'Strategies' },
  { id: 'reference',       label: 'Reference' },
  { id: 'setup',           label: 'Setup' },
  { id: 'help',            label: 'Help' },
];
